import React from 'react';
import PropTypes from 'prop-types';

import {cn} from 'spa/css';

class Alert extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['success', 'error']).isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    lightTheme: PropTypes.bool,
  };

  render() {
    const {
      type, title, text, className, lightTheme, ...rest
    } = this.props;
    return (
      <div
        {...rest}
        className={`alert alert--${type} ${className || ''}`}>
        <div className="alert__body">
          {title ? (
            <p
              className={cn(
                'alert__title',
                lightTheme && 'alert__title--light',
              )}>
              {title}
            </p>
          ) : null}
          {text ? (
            <p
              className={cn(
                'alert__text',
                lightTheme && 'alert__text--light',
              )}>
              {text}
            </p>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./spa/Components/Alert.jsx